export const getOtherDependentFilters = (
  appliedCheckboxes,
  categoryKey,
  filterKey
) =>
  appliedCheckboxes.filter(
    (item) =>
      item.parentFilterKey === categoryKey && item.groupedBy === filterKey
  );

export const getFilterAlreadyApplied = (
  appliedCheckboxes,
  categoryKey,
  filterKey
) =>
  appliedCheckboxes.find(
    (item) => item.filterKey === filterKey && item.categoryKey === categoryKey
  );

export const getFilterAlreadyAppliedCheckBoxGroup = (
  appliedCheckboxes,
  categoryKey,
  filterKey,
  groupedBy
) =>
  appliedCheckboxes.find((item) => {
    if (Boolean(item.groupedBy))
      return (
        item.filterKey === filterKey &&
        item.categoryKey === categoryKey &&
        item.groupedBy === groupedBy
      );
    return item.filterKey === filterKey && item.categoryKey === categoryKey;
  });
